export default {
    最新公告:'Announcements',
    公司治理:'Corporate Governance',

    companyProfile:{
       title:'About NBHX',
        desc1:'',
        desc:'We are an international group established in 1988 and listed on the Shenzhen Stock Exchange in 2005, and specialize in the design, development, production, sales and after-sales service of parts for medium and high-grade passenger cars. Headquartered in China with branches in North America, Europe and South Asia, we have currently built more than 60 production bases and 3 research and development centers in the world with more than 15,000 employees worldwide.<br>' +
        'As one of the world\'s top 500 auto parts companies, we provide many internationally renowned auto brands with such products and related services as interior and exterior trims, metal parts, automotive electronics and lightweight materials. Our main customers include Volkswagen, BMW, Ford, General Motors, Jaguar Land Rover, Benz, Toyota, Volvo, SAIC Motor, FAW Car, Dongfeng Nissan, etc.<br>' +
        "We aim to be an excellent supplier in the global auto industry with innovation of prospective technologies and by insistently \"creating the stage for each employee to realize value\" and \"persisting in sustained profitability and prudent financial policies so as to benefit shareholders, satisfy customers, and support partners development\"."
    },
    products:{
        title:'Core Products',
        desc:'The company specializes in the design, development, production and sales of auto parts. The products cover automotive interior and exterior trim, body metal parts, automotive electronics and new energy vehicle related products.'
    },
    investorRelations:{
        name:'NBHX (002048)',
        dayHigh:'The Highest Price',
        dayOpen:'The Opening Price',
        dayLow:'The Lowest Price',
        yesterdayClose:'Closing Price Yesterday',
        volume:'Deal Volume (10,000 lots)',
        turnover:'Deal Amount (CNY 10,000)'
    },
    news:{
        title:'NBHX News',
    },
}
